"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var castArray_1 = __importDefault(require("lodash/castArray"));
var toString_1 = __importDefault(require("lodash/toString"));
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("./index"));
var SingleValueFilterItem = /** @class */ (function (_super) {
    __extends(SingleValueFilterItem, _super);
    function SingleValueFilterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validOperators = ["in", "like"];
        _this.selectNothing = function (e) {
            _this.setState({
                selectedValues: undefined,
            });
        };
        _this.checkValue = function (e, value) {
            var add = e.target.checked;
            if (add) {
                _this.setState({
                    selectedValues: value,
                });
            }
        };
        _this.renderSelect = function () {
            var localization = _this.props.localization;
            var _a = _this.state, selectedValues = _a.selectedValues, filter = _a.filter;
            var select;
            if (filter.length > 0) {
                select = react_1.default.createElement("strong", null, localization.foundResults.replace("%COUNT", "" + _this.filteredValues.length));
            }
            else {
                /* eslint-disable @typescript-eslint/restrict-template-expressions */
                select = (react_1.default.createElement("label", { key: _this.props.id + "_select_all" },
                    react_1.default.createElement("input", { type: "radio", checked: castArray_1.default(selectedValues).length === 0, onChange: _this.selectNothing }),
                    react_1.default.createElement("strong", null, localization.selectNothing)));
                /* eslint-enable @typescript-eslint/restrict-template-expressions */
            }
            return select;
        };
        _this.renderRows = function () {
            var selectedValues = _this.state.selectedValues;
            return _this.filteredValues.map(function (item) {
                var key = toString_1.default(item.id);
                var value = item.name;
                var isChecked = castArray_1.default(selectedValues).indexOf(key) >= 0;
                var handler = function (e) {
                    _this.checkValue(e, key);
                };
                return (react_1.default.createElement("label", { key: "option_" + item.id + "_" + value.replace(/ /g, "_"), className: "option" },
                    react_1.default.createElement("input", { type: "radio", checked: isChecked, onChange: handler }),
                    react_1.default.createElement("span", { className: "text" }, value)));
            });
        };
        return _this;
    }
    return SingleValueFilterItem;
}(index_1.default));
exports.default = SingleValueFilterItem;
//# sourceMappingURL=SingleValueFilterItem.js.map